import type { InputCardGroupProps } from "@/components/inputs/types";
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
  FieldTitle,
} from "@/components/ui/field";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";

const CustomRadioGroup = ({
  options,
  value,
  defaultValue,
  onValueChange,
  name = "radio-card",
  disabled,
  className,
}: InputCardGroupProps) => {
  return (
    <RadioGroup
      value={value as string}
      defaultValue={defaultValue as string}
      onValueChange={(next) => onValueChange?.(String(next))}
      disabled={disabled}
      className={cn(className)}
    >
      {options.map((option) => {
        const id = `${name}-${option.value}`;
        const Icon = option.icon;

        return (
          <FieldLabel
            key={option.value}
            htmlFor={id}
            className={cn(
              "border border-accent bg-background transition-colors",
              "has-data-checked:border-primary has-data-checked:bg-secondary has-data-checked:text-primary",
              "has-data-checked:**:data-[slot=field-description]:text-primary-foreground/85",
            )}
          >
            <Field
              orientation="horizontal"
              className="items-center"
              data-disabled={option.disabled || undefined}
            >
              <FieldContent>
                <FieldTitle className="font-normal group-has-data-checked/field-label:font-bold">
                  {Icon ? (
                    <span
                      aria-hidden="true"
                      className="rounded-sm bg-background p-1"
                    >
                      <Icon size={16} color="#60407d" />
                    </span>
                  ) : null}
                  {option.label}
                </FieldTitle>
                {option.description ? (
                  <FieldDescription>{option.description}</FieldDescription>
                ) : null}
              </FieldContent>
              <RadioGroupItem
                value={option.value}
                id={id}
                disabled={option.disabled}
              />
            </Field>
          </FieldLabel>
        );
      })}
    </RadioGroup>
  );
};

export default CustomRadioGroup;
